export const FETCH_PROD_HOST = 'info.cian.ru';
